export default __webpack_public_path__ + "static/media/beyond-carbon-neutrality.a051abdd.jpg";